module.exports = window;


//////////////////
// WEBPACK FOOTER
// external "window"
// module id = 116
// module chunks = 1